export default __webpack_public_path__ + "static/media/popcorn-cola.9d7af2dd.webp";